<template>
    <div>
        <div v-for="page in page.ShopPages.items" class="uk-card uk-card-default uk-card-small uk-grid-collapse uk-child-width-1-2@s uk-margin"
             uk-grid>

             <div class="uk-card-media-left uk-cover-container">
                 <img v-if="page.Asset.id" :src="page.Asset.src" :alt="page.Asset.description" uk-cover>
                 <canvas width="1800" height="1200"></canvas>
             </div>

            <div>
                <div class="uk-card-body">
                    <article class="uk-article">

                        <a class="uk-h2" :href="page.ShopPage.href">{{ page.ShopPage.name }}</a>

<!--
                        <p class="uk-article-meta">Written by <a href="#">Super User</a> on
                            <time>12 April 2012</time>
                        </p>
-->

                        <p v-html="page.ShopPage.description"></p>

                        <div class="uk-grid-small" uk-grid>

                            <div>
                                <a class="uk-button uk-button-text" :href="page.ShopPage.href">Перейти</a>
                            </div>

<!--                            <div>
                                <a class="uk-button uk-button-text" href="#">5 Comments</a>
                            </div>-->

                        </div>

                    </article>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "SearchShopPages",
        props: {
            result: {
                type: Object,
                required: true
            },
        },
        created() {
            this.loadPage(1);
        },
        data() {
            return {
                page: {
                    ShopPages: {},
                },
                params: {
                    page: 1,
                    indexName: this.result.indexName,
                    query: this.result.query
                }
            }
        },
        methods: {
            loadPage(page) {
                this.params.page = page;
                this.fetchShopPages('/search/results', this.params);
            },
            fetchShopPages(href, params = {}) {
                this.loading = true;
                this.href = href;
                this.$http.get(href, {
                    params: params
                }).then(response => {

                    this.page = response.body.data;

                    this.loading = false;

                }, (response) => {
                    this.loading = false;
                })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SearchShopPages.vue?65eb5f5a